export default __webpack_public_path__ + "static/media/andyjackored.fe9649be.png";